export function areStringArraysEqual(
    first: readonly string[],
    second: readonly string[],
): boolean {
    if (first === second) {
        return true
    }
    if (first.length !== second.length) {
        return false
    }

    for (let i = 0; i < first.length; i += 1) {
        if (first[i] !== second[i]) {
            return false
        }
    }

    return true
}
